module.exports = __webpack_public_path__ + "img/framenew_box03.48282dba.jpg";